<template>
  <layout>
  <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
  <div class="el-form-content" slot="content">
    <el-form size="mini" label-width="80px">
      <el-row>
        <el-col>
          <el-image style="width: 98%; height: 100%" :src="url" :fit="fits" @click="closeModal" />
        </el-col>
      </el-row>
    </el-form>
  </div>
</layout>
</template>

<script>
/**
* * components
*/
import Layout from '@/components/Slot/ModalSlot.vue';
import {AgGridVue} from 'ag-grid-vue';

import mixin from './index';
 
 

export default {
  mixins: [mixin],
  props: {
    imgobj: {
          Type: Array
          , required: false
      },
      custNo: {
          Type: String
          , required: false
      }
  },
  components: {Layout, AgGridVue},
  data() {
      return {
          title: '현장사진',
          form: {
          },
          fits: 'fill', // ['fill', 'contain', 'cover', 'none', 'scale-down'],
          url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
          
      }
  },
  created() {
    this.form = this.imgobj;
    this.$bus.$on('input', (val) => {
        console.log('-> input bus on ', val);
    });
  },
  mounted() {
      //pop slots modal move
      $(".animation-content").addClass('pop_min2');
      $(".animation-content").draggable({'cancel':'.modal-card-body'});
      //ModalSlot open z-index change
      $('.lnb').css('z-index', '4');
  },
  destroyed() {
      //ModalSlot open z-index change
      $('.lnb').css('z-index', '7');
  },
  methods: {
      
      closeModal() {
          this.$parent.close();
      }
  }

}
</script>

<style lang="scss" scoped>

.el-form-content {
  border: 1px solid #d7d7d7 !important;
  padding: 10px 10px 10px 0;
  border-radius: 5px; 
  margin-left: 0px;
    .el-form-item {
        margin-left: -5px;
        // margin-right: 0px;
    }
}
</style>